





























import linkDirective from '@/shared/directives/link-directive';
import scrollPositionDirective from '@/shared/directives/scroll-position-directive';
import ISubCategory from '../models/sub-category';
import { defineComponent, onMounted, PropType, ref } from '@vue/composition-api';
import { useGetters } from 'vuex-composition-helpers';

    declare global {
        interface Window {
            dataLayer: any[]
        }
    }

    export default defineComponent({
        name: 'Arrow',
        directives: {
            linkDirective,
            scrollPositionDirective
        },
        props: {
            items: { type: Array as PropType<ISubCategory[]>, required: true },
            selectedItem: { type: String, required: true }
        },
        setup(_, { emit }) {
            const { selectCategoryUrl } = useGetters(['selectCategoryUrl'])
            const list = ref<HTMLElement | null>(null)
            const childElement = ref<HTMLElement | null>(null)

            onMounted(() => {
                if (list.value) {
                    childElement.value = list.value.lastChild as HTMLElement
                }

                if (window.dynamicColorSystem && typeof window.dynamicColorSystem.applyDynamicColors === 'function') {
                    window.dynamicColorSystem.applyDynamicColors()
                }
            })

            const trackTileClick = (item: ISubCategory) => {
                const url = selectCategoryUrl.value(item)
                const clickText = item.name
                const clickUrl = resolveUrl(url)

                pushDataLayerEvent('tile_sub_click', clickText, clickUrl)
            }

            const trackTileSubClick = (item: ISubCategory) => {
                emit('select', item)

                const clickText = item.name
                pushDataLayerEvent('tile_sub_click', clickText, 'no link')
            }

            const resolveUrl = (url: string): string => {
                if (!url) {
                    return '';
                }
                return url.startsWith('http')
                    ? url
                    : `${window.location.origin}${url}`;
            };

            const pushDataLayerEvent = (event: string, clickText: string, clickUrl: string) => {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                    event,
                    click_text: clickText,
                    click_url: clickUrl
                })
            }

            return {
                selectCategoryUrl,
                childElement,
                list,
                trackTileClick,
                trackTileSubClick
            }
        }
    })
